import {createSelector} from 'reselect';
import isCAASSite from './isCAASSite';
import isLegacySite from './isLegacySite';
import {getSettings} from './selectors';

export default createSelector(
  [getSettings, isCAASSite, isLegacySite],
  (settings, caas, legacy) => !!(settings.artemis_integration_enabled && !caas && !legacy),
);
